import phrase from "./categories/phrase"
import beforeAndAfter from "./categories/beforeAndAfter"
import onTheMap from "./categories/onTheMap"

export default [...phrase, ...beforeAndAfter, ...onTheMap]
